import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

import { UtilsService } from '../../services/helpers/utils.service';
import { ModalErrorComponent } from '../../sections/modal-error/modal-error.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { IFileInfo } from '../../models/models';

@Component({
  selector: 'app-file-selector',
  templateUrl: './file-selector.component.html',
})
export class FileSelectorComponent implements OnInit {

  private _fileSizeErrorTranslate: string;
  private _fileTypeErrorTranslate: string;
  private _fileAlreadyExitsErrorTranslate: string;

  constructor(
    private _translateService: TranslateService,
    private _utilsService: UtilsService,
    private _modalService: NgbModal
  ) {
    this.fileList = [];
    this.allowFileExtensions = "";
    this.fileList.length
  }

  @Input() viewType: 'fileNameList' | 'imageList';
  @Input() headerText: string;
  @Input() addButtonText: string;
  @Input() deleteButtonText: string;
  @Input() maxFileSize: number;
  @Input() maxFileCount?: number;
  @Input() allowFileExtensions: string;
  @Input() fileList: IFileInfo[];


  ngOnInit() {
    this._initTranslations();
  }

  private _initTranslations() {
    this._translateService.get(
      [
        "Common.FileSizeError",
        "Common.FileTypeError",
        "Common.FileAlreadyExitsError"
      ])
      .subscribe((result) => {
        this._fileSizeErrorTranslate = result["Common.FileSizeError"];
        this._fileTypeErrorTranslate = result["Common.FileTypeError"];
        this._fileAlreadyExitsErrorTranslate = result["Common.FileAlreadyExitsError"];
      });
  }

  private _openModalWindow(content: any) {
    const modalRef = this._modalService.open(content, { windowClass: 'custom-position-modal' });
    return modalRef;
  }

  public fileAsDataUrl(fileInfo: IFileInfo): string {
    if (fileInfo.fileContentType && fileInfo.fileContent) {
      return `url('data:${fileInfo.fileContentType};base64,${fileInfo.fileContent}')`;
    }
    else if (fileInfo.thumbnailUrl) {
      return `url('${fileInfo.thumbnailUrl}')`;
    }
    return '';
  }

  public async addButtonClick(event: Event): Promise<void> {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();

    const target = event.target as HTMLInputElement;
    const files = target.files as FileList;

    const result = this._utilsService.handleFileInput(
      files,
      this.maxFileSize,
      this.allowFileExtensions,
      this._fileSizeErrorTranslate,
      this._fileTypeErrorTranslate
    );

    if (!result.result) {
      const modalRef = this._openModalWindow(ModalErrorComponent);
      modalRef.componentInstance.errors = [result.error];
      this._utilsService.cleanFileInput(target);
      return;
    }

    const fileExists: boolean = this.fileList.filter((item) => item.fileName === result.file.name).length > 0;
    if (fileExists) {
      const modalRef = this._openModalWindow(ModalErrorComponent);
      modalRef.componentInstance.errors = [this._fileAlreadyExitsErrorTranslate];
      this._utilsService.cleanFileInput(target);
      return;
    }

    var fileInfo = {
      id: 0,
      fileContent: '',
      fileName: result.file.name,
      fileContentType: result.file.type,
      thumbnailUrl: null,
      fileUrl: null,
      selectedFile: result.file,
    } as IFileInfo;
    
    if (this.viewType == 'imageList') {
      fileInfo.fileContent = await this._getBase64(files[0]);
    }
    
    this.fileList.push(fileInfo);
    this._utilsService.cleanFileInput(target);
  }

  public deleteButtonClick(event: Event, fileInfo: IFileInfo, fileIndex: number): void {
    this.fileList.splice(fileIndex, 1);
  }

  private _getBase64(file: File): Promise<string> {
    return new Promise<string>(resolve => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        var arr = new Uint8Array(e.target.result);
        var str = '';
        for (var i = 0; i < arr.length; i++) {
          str += String.fromCharCode(arr[i]);
        }
        var base64: string = window.btoa(str);
        resolve(base64);
      };
      reader.readAsArrayBuffer(file);
    });
  }
}
